export function createCuentaContable() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    ClaveErp: '',
    Nivel: 0,
    EsActivo: true,
    Clave2: ''
  };
}
